import * as React from 'react';
import { SVGProps } from 'react';

const SvgCookieIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24px" height="24px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.745 5.373a2.455 2.455 0 0 1 .032-1.298.805.805 0 0 0 .025-.417.813.813 0 0 0-.413-.56.813.813 0 0 0-.41-.098A9 9 0 1 0 21 12a.818.818 0 0 0-1.058-.782 2.454 2.454 0 0 1-3.068-3.068.818.818 0 0 0-1.023-1.023 2.455 2.455 0 0 1-3.104-1.754Zm-4.836.505A7.364 7.364 0 0 1 11.038 4.7a4.095 4.095 0 0 0 1.197 2.974 4.091 4.091 0 0 0 2.893 1.198 4.092 4.092 0 0 0 4.172 4.09 7.365 7.365 0 0 1-12.507 4.245A7.363 7.363 0 0 1 7.91 5.877Zm2.045 3.258a.818.818 0 0 0-1.636 0v.009a.818.818 0 1 0 1.636 0v-.009Zm5.319 4.91c.451 0 .818.366.818.818v.008a.818.818 0 1 1-1.637 0v-.008c0-.452.367-.819.819-.819ZM12.818 12a.818.818 0 1 0-1.636 0v.008a.818.818 0 1 0 1.636 0V12Zm-1.636 3.273c.452 0 .818.366.818.818v.008a.818.818 0 1 1-1.636 0v-.008c0-.452.366-.818.818-.818Zm-2.455-1.637a.818.818 0 0 0-1.636 0v.009a.818.818 0 1 0 1.636 0v-.009Z"
      fill="currentColor"
    />
  </svg>
);

export default SvgCookieIcon;
